<template>
    <div class="contentNum">
        <div class="contentCenterTitle Title-left">企业销售金额：</div>
        <div class="dl">
            <div class="centerNum" v-for="(item, i) in num3length" :key="i"><span>{{ num3total[i] }}</span></div>
            <div class="contentCenterTitle Title-right">元</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'template4.centerTop4',
    // 传入对象格式，格式内num123分别对应前几个，numlength对应格子长度
    props: {
        vdata: {
            type: Object,
            default: () => { }
            // default: {
            //     num1: 532,
            //     num2: 699,
            //     num3: 598
            // }
        },
    },
    data() {
        return {
            num1length: 3,
            num2length: 9,
            num3length: 8,
            num1: 696,
            num1total: 0,
            num2: 525,
            num2total: 0,
            num3: 98161233,
            num3total: 0,
            timer1: null,
        }
    },
    mounted() {
        this.setdata()
        this.timer1 = setInterval(() => {
            this.indexSumnew()
        }, 300)
        this.indexSumnew()
    },
    watch: {
        vdata(n) {
            this.setdata()
        }
    },
    methods: {
        setdata() {
            if (this.vdata) {
                const vdata = Object.keys(this.vdata)
                if (vdata.length) {
                    this.num1 = this.vdata.num1 || 0
                    this.num2 = this.vdata.num2 || 0
                    this.num3 = this.vdata.num3 || 0
                }
            }
        },
        numreduce(num, len) {
            let start = ''
            let numend = num.toString()
            if (numend.length < len) {
                for (let i = 0; i < (len - numend.length); i++) {
                    start = start + '0'
                }
            }
            return start + numend
        },
        indexSumnew() {
            if (+this.num1 !== +this.num1total || this.num1 == 0) {
                let num = this.numreduce(this.num1, this.num1length).split('')
                let strnum = this.numreduce(this.num1total, this.num1length).split('')
                strnum.forEach((item, i) => {
                    if (+item < +num[i]) {
                        strnum[i] = +item + 1
                    }
                })
                this.num1total = strnum.join('')
            }
            if (+this.num2 !== +this.num2total || this.num2 == 0) {
                let num = this.numreduce(this.num2, this.num2length).split('')
                let strnum = this.numreduce(this.num2total, this.num2length).split('')
                strnum.forEach((item, i) => {
                    if (+item < +num[i]) {
                        strnum[i] = +item + 1
                    }
                })
                this.num2total = strnum.join('')
            }
            if (+this.num3 !== +this.num3total || this.num3 == 0) {
                let num = this.numreduce(this.num3, this.num3length).split('')
                let strnum = this.numreduce(this.num3total, this.num3length).split('')
                strnum.forEach((item, i) => {
                    if (+item < +num[i]) {
                        strnum[i] = +item + 1
                    }
                })
                this.num3total = strnum.join('')
            }
            if (+this.num1 == +this.num1total && +this.num2 == +this.num2total && +this.num3 == +this.num3total) {
                clearInterval(this.timer1)
                this.timer1 = null
                const _this = this
                setTimeout(() => {
                    this.num1total = 0
                    this.num2total = 0
                    this.num3total = 0
                    this.timer1 = setInterval(() => {
                        _this.indexSumnew()
                    }, 300);
                }, 5000)
            }
        },
    },
    beforeDestroy() {
        // 页面销毁清除定时器
        if (this.timer1) {
            clearInterval(this.timer1);
        }
    },
}
</script>

<style scoped lang="scss">
@font-face {
    font-family: "YeJinShuZi";
    src: url("../../assets/fonts/YeJinShuZi.woff2");
}

.contentNum {
    width: 92%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 34px auto 0 auto;
    z-index: 999;
    position: relative;
}

.contentCenterTitle {
    font-family: YouSheBiaoTiHei;
    font-weight: 400;
    font-size: 24px;
    color: #CDE5ED;
}
.Title-left{
    margin: 4px 20px 0 -60px;
}
.Title-right{
    margin: 14px 20px 0;
}
.centerNum {
    width: 41px;
    width: 41px;
    height: 54px;
    background: url(../../assets/template4/num-bg.png) no-repeat;
    background-size: 100%;
    margin: 4px 7px 0;
    font-family: "lcdd";
    font-size: 45px;
    color: #fff;
    line-height: 50px;
    text-align: left;

    span {
        font-family: DIN;
        font-weight: bold;
        font-size: 36px;
        color: #FFFFFF;
        line-height: 8px;
        padding-left: 9px;
    }
}

.dl {
    display: flex
}
</style>